module.exports = __webpack_public_path__ + "img/ylb-en9.08c715f5.png";